module.exports = __webpack_public_path__ + "img/receipt23.bf9ab930.png";